<template>
  <div class="ck-form">
    <!-- ① 基础信息：公司 / 设备编号 / 设备名称（均只读，由 props 带出） -->
    <!-- <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>基础信息</span>
      </div>
      <div class="info-card">
        <van-field
          class="ro-field"
          label="公司"
          :model-value="companyText"
          readonly
          placeholder="-"
        />
        <van-field
          class="ro-field"
          label="设备编号"
          :model-value="data.eqpInfo.eqp_code"
          readonly
          placeholder="-"
        />
        <van-field
          class="ro-field"
          label="设备名称"
          :model-value="data.eqpInfo.eqp_name"
          readonly
          placeholder="-"
        />
      </div>
    </div> -->

    <!-- ② 点检项目组：选择 + 展开查看点检项明细 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="req">*</span>
        <span>点检项目组</span>
        <span class="title-action" @click="openCheckGroupDialog">选择</span>
      </div>

      <div v-if="data.itemGroupDataList.length" class="sel-list">
        <div class="sel-card" v-for="g in data.itemGroupDataList" :key="g.id">
          <div class="sel-head" @click="toggleGroup(g)">
            <span class="sel-name">{{ g.group_name }}</span>
            <van-icon
              class="sel-arrow"
              :name="g._expanded ? 'arrow-up' : 'arrow-down'"
            />
            <van-icon class="sel-del" name="cross" @click.stop="removeGroup(g)" />
          </div>

          <div class="sel-body" v-if="g._expanded">
            <div v-if="g._childLoading" class="sel-loading">
              <van-loading size="16">加载中...</van-loading>
            </div>
            <template v-else>
              <div
                class="item-row"
                v-for="(it, ii) in g._children"
                :key="it.id || ii"
              >
                <div class="item-title">
                  <span class="item-name">{{ it.item_name || "-" }}</span>
                </div>
                <div class="kv">
                  <span class="kv-k">是否拍照</span>
                  <span class="kv-v" :class="{ 'is-photo': it.need_photo == 1 }">
                    {{ it.need_photo == 1 ? "是" : "否" }}
                  </span>
                </div>
                <div class="kv" v-if="it.station_name">
                  <span class="kv-k">部位</span>
                  <span class="kv-v">{{ it.station_name }}</span>
                </div>
                <div class="kv">
                  <span class="kv-k">类型</span>
                  <span class="kv-v">{{
                    checkTypeText(it.check_type) || "-"
                  }}</span>
                </div>
                <div class="kv">
                  <span class="kv-k">类型参考值</span>
                  <span class="kv-v">{{ getCheckTypeInfo(it) || "-" }}</span>
                </div>
              </div>
              <div class="empty-tip" v-if="!g._children.length">暂无点检项</div>
            </template>
          </div>
        </div>
      </div>
      <div class="empty-card" v-else @click="openCheckGroupDialog">
        请选择点检项目组
      </div>
      <div class="err-tip" v-if="errors.check_item_list">
        {{ errors.check_item_list }}
      </div>
    </div>

    <!-- ③ 班组：选择 + 展开查看班组成员 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="req">*</span>
        <span>班组</span>
        <span class="title-action" @click="openTeamDialog">选择</span>
      </div>

      <div v-if="data.teamDataList.length" class="sel-list">
        <div class="sel-card" v-for="t in data.teamDataList" :key="t.id">
          <div class="sel-head" @click="toggleTeam(t)">
            <span class="sel-name">{{ t.team_name }}</span>
            <van-icon
              class="sel-arrow"
              :name="t._expanded ? 'arrow-up' : 'arrow-down'"
            />
            <van-icon class="sel-del" name="cross" @click.stop="removeTeam(t)" />
          </div>

          <div class="sel-body" v-if="t._expanded">
            <div
              class="member-row"
              v-for="(m, mi) in t._children"
              :key="m.emp_code || mi"
            >
              <span class="member-name">{{ memberText(m) }}</span>
              <span class="member-tag" :class="{ 'is-improve': isImprove(m) }">
                {{ isImprove(m) ? "改善组人员" : "非改善组" }}
              </span>
            </div>
            <div class="empty-tip" v-if="!t._children.length">暂无成员</div>
          </div>
        </div>
      </div>
      <div class="empty-card" v-else @click="openTeamDialog">请选择班组</div>
      <div class="err-tip" v-if="errors.team_id">{{ errors.team_id }}</div>
    </div>

    <!-- 「选择点检项目组」弹窗 -->
    <van-popup
      v-model:show="data.checkGroupDialog"
      position="bottom"
      round
      :style="{ height: '72%' }"
    >
      <div class="dlg">
        <div class="dlg-head">
          <span class="dlg-cancel" @click="data.checkGroupDialog = false">取消</span>
          <span class="dlg-title">选择点检项目组</span>
          <span class="dlg-confirm" @click="confirmCheckGroup">确定</span>
        </div>

        <div class="dlg-body">
          <div v-if="data.checkGroupLoading" class="sel-loading">
            <van-loading size="20" vertical>加载中...</van-loading>
          </div>
          <van-list
            v-else
            v-model:loading="data.checkGroupLoadingMore"
            :finished="data.checkGroupFinished"
            :error="data.checkGroupError"
            :immediate-check="false"
            finished-text="没有更多了"
            error-text="加载失败，点击重试"
            @load="loadMoreCheckGroup"
          >
            <div
              class="opt-row"
              v-for="g in data.checkGroupOptions"
              :key="g.id"
            >
              <div class="opt-main" @click="toggleTempId('checkGroup', g.id)">
                <span class="opt-name">{{ g.group_name }}</span>
                <van-icon
                  class="opt-arrow"
                  :name="g._open ? 'arrow-up' : 'arrow-down'"
                  @click.stop="toggleGroupItems(g)"
                />
                <van-icon
                  class="opt-check"
                  :name="isPicked('checkGroup', g.id) ? 'success' : 'circle'"
                  :color="isPicked('checkGroup', g.id) ? '#1989fa' : '#dcdee0'"
                />
              </div>

              <!-- 展开：明细不支持一次全量返回，展开时按 group_id 懒加载 -->
              <div class="opt-members" v-if="g._open">
                <div v-if="g._childLoading" class="sel-loading">
                  <van-loading size="14">加载中...</van-loading>
                </div>
                <template v-else>
                  <div
                    class="item-row"
                    v-for="(it, ii) in g._children"
                    :key="it.id || ii"
                  >
                    <div class="item-title">
                      <span class="item-name">{{ it.item_name || "-" }}</span>
                    </div>
                    <div class="kv">
                      <span class="kv-k">是否拍照</span>
                      <span
                        class="kv-v"
                        :class="{ 'is-photo': it.need_photo == 1 }"
                      >
                        {{ it.need_photo == 1 ? "是" : "否" }}
                      </span>
                    </div>
                    <div class="kv" v-if="it.station_name">
                      <span class="kv-k">部位</span>
                      <span class="kv-v">{{ it.station_name }}</span>
                    </div>
                    <div class="kv">
                      <span class="kv-k">类型</span>
                      <span class="kv-v">{{
                        checkTypeText(it.check_type) || "-"
                      }}</span>
                    </div>
                    <div class="kv">
                      <span class="kv-k">类型参考值</span>
                      <span class="kv-v">{{ getCheckTypeInfo(it) || "-" }}</span>
                    </div>
                  </div>
                  <div class="empty-tip" v-if="!g._children.length">
                    暂无点检项
                  </div>
                </template>
              </div>
            </div>
            <van-empty
              v-if="!data.checkGroupOptions.length"
              image-size="60"
              description="暂无可选项目组"
            />
          </van-list>
        </div>
      </div>
    </van-popup>

    <!-- 「选择班组」弹窗 -->
    <van-popup
      v-model:show="data.teamDialog"
      position="bottom"
      round
      :style="{ height: '72%' }"
    >
      <div class="dlg">
        <div class="dlg-head">
          <span class="dlg-cancel" @click="data.teamDialog = false">取消</span>
          <span class="dlg-title">选择班组</span>
          <span class="dlg-confirm" @click="confirmTeam">确定</span>
        </div>

        <div class="dlg-body">
          <div v-if="data.teamLoading" class="sel-loading">
            <van-loading size="20" vertical>加载中...</van-loading>
          </div>
          <van-list
            v-else
            v-model:loading="data.teamLoadingMore"
            :finished="data.teamFinished"
            :error="data.teamError"
            :immediate-check="false"
            finished-text="没有更多了"
            error-text="加载失败，点击重试"
            @load="loadMoreTeam"
          >
            <div
              class="opt-row"
              v-for="t in data.teamOptions"
              :key="t.id"
            >
              <div class="opt-main" @click="toggleTempId('team', t.id)">
                <span class="opt-name">{{ t.team_name }}</span>
                <span class="opt-sub">{{ (t.members || []).length }} 人</span>
                <van-icon
                  class="opt-arrow"
                  :name="t._open ? 'arrow-up' : 'arrow-down'"
                  @click.stop="toggleTeamMembers(t)"
                />
                <van-icon
                  class="opt-check"
                  :name="isPicked('team', t.id) ? 'success' : 'circle'"
                  :color="isPicked('team', t.id) ? '#1989fa' : '#dcdee0'"
                />
              </div>

              <!-- 班组展开：成员列表（随列表一起返回，本地即时渲染，无需二次请求） -->
              <div class="opt-members" v-if="t._open">
                <div
                  class="member-row"
                  v-for="(m, mi) in t.members || []"
                  :key="m.emp_code || mi"
                >
                  <span class="member-name">{{ memberText(m) }}</span>
                  <span class="member-tag" :class="{ 'is-improve': isImprove(m) }">
                    {{ isImprove(m) ? "改善组人员" : "非改善组" }}
                  </span>
                </div>
                <div class="empty-tip" v-if="!(t.members || []).length">
                  暂无成员
                </div>
              </div>
            </div>
            <van-empty
              v-if="!data.teamOptions.length"
              image-size="60"
              description="暂无可选班组"
            />
          </van-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reactive, ref, computed, onMounted } from "vue";
import { Toast } from "vant";
import { GetAllCompany, GetEqpPageList, GetTeamEmp } from "@/api/ems/eqpInfo.js";
import {
  GetCheckItemGroupList,
  GetCheckItemListByGroupId,
} from "@/api/ems/checkItem.js";

// 点检项类型：0 布尔判定 / 1 值范围 / 2 值比较 / 3 文本判定
const CHECK_TYPE_LIST = [
  { label: "布尔判定", value: 0 },
  { label: "值范围", value: 1 },
  { label: "值比较", value: 2 },
  { label: "文本判定", value: 3 },
];

// 比较运算符：与 check/index.vue 的 getDataInfo 保持一致
const COMPARE_OPERATOR = {
  1: "=",
  2: ">",
  3: ">=",
  4: "<",
  5: "<=",
};

export default {
  name: "CheckWorkOrderForm",
  props: {
    company_id: { type: String, default: "" },
    eqp_info_id: { type: String, default: "" },
  },
  setup(props, { expose }) {
    const data = reactive({
      // 公司列表（只用于把 company_id 显示成「编码-名称」）
      company_list: [],
      // 设备展示信息（由 eqp_info_id 查接口带出，只读展示）
      eqpInfo: {
        eqp_name: "",
        eqp_code: "",
      },
      // 弹窗开关
      checkGroupDialog: false,
      teamDialog: false,
      // 弹窗数据源
      checkGroupOptions: [],
      teamOptions: [],
      // 弹窗分页状态（下拉加载）
      checkGroupLoading: false, // 首屏加载
      checkGroupLoadingMore: false, // 触底加载
      checkGroupFinished: false,
      checkGroupError: false,
      checkGroupPage: 1,
      checkGroupPageSize: 20,
      checkGroupTotal: 0,
      teamLoading: false,
      teamLoadingMore: false,
      teamFinished: false,
      teamError: false,
      teamPage: 1,
      teamPageSize: 20,
      // 弹窗内的临时勾选（确定后才回填到已选列表）
      tempCheckGroupIds: [],
      tempTeamIds: [],
      // 已选：点检项目组 / 班组
      itemGroupDataList: [],
      teamDataList: [],
    });

    // 两个列表型字段的校验错误（与 PC 端 el-form rules 等价）
    const errors = reactive({ check_item_list: "", team_id: "" });

    // ===== 基础信息 =====
    // 公司展示：company_code-company_name
    const companyText = computed(() => {
      const hit = (data.company_list || []).find(
        (c) =>
          String(c.company_id ?? c.id ?? "") ===
          String(props.company_id ?? "")
      );
      return hit
        ? `${hit.company_code ?? ""}-${hit.company_name ?? ""}`
        : "";
    });

    const getAllCompany = () => {
      GetAllCompany().then((res) => {
        if (res && res.code == 200) {
          data.company_list = res.data || res.rows || [];
        }
      });
    };

    // 按设备 id 带出设备编号 / 名称（接口 EqpInfo/GetEqpPageList，数据在 res.rows）
    const getEqpInfoById = (id) => {
      if (!id) return;
      GetEqpPageList({ id: id, page: 1, pageSize: 10 }).then((res) => {
        if (res && res.code == 200) {
          const rows = res.rows || res.data || [];
          // 后端若忽略 id 条件返回整页，这里按 id 精确匹配，避免取错设备
          const hit =
            rows.find((r) => String(r.id) === String(id)) || rows[0];
          if (hit) {
            data.eqpInfo.eqp_name = hit.eqp_name;
            data.eqpInfo.eqp_code = hit.eqp_code;
          } else {
            Toast("未找到设备信息");
          }
        } else {
          Toast((res && res.msg) || "获取设备信息失败");
        }
      });
    };

    // ===== 通用：id 归一 & 临时勾选 =====
    const idOf = (v) => String(v ?? "");

    const isPicked = (type, id) => {
      const list =
        type === "checkGroup" ? data.tempCheckGroupIds : data.tempTeamIds;
      return list.includes(idOf(id));
    };

    const toggleTempId = (type, id) => {
      const key = idOf(id);
      const list =
        type === "checkGroup" ? data.tempCheckGroupIds : data.tempTeamIds;
      const idx = list.indexOf(key);
      if (idx >= 0) list.splice(idx, 1);
      else list.push(key);
    };

    // ===== ② 点检项目组 =====
    // 字段兼容：不同接口可能返回 id / group_id
    // 明细接口不支持一次返回全部，故每行自带展开态，展开时按 group_id 懒加载
    const normalizeCheckGroups = (rows) =>
      (Array.isArray(rows) ? rows : []).map((g) => ({
        id: g.id ?? g.group_id ?? g.check_group_id ?? "",
        group_name: g.group_name ?? g.name ?? g.groupName ?? "",
        _open: false,
        _children: [],
        _childLoaded: false,
        _childLoading: false,
      }));

    // 分页取数：reset=true 拉第一页，reset=false 触底加载下一页
    const loadCheckGroups = async (reset = false) => {
      if (reset) {
        data.checkGroupPage = 1;
        data.checkGroupOptions = [];
        data.checkGroupTotal = 0;
        data.checkGroupFinished = false;
        data.checkGroupError = false;
        data.checkGroupLoading = true;
      } else {
        if (data.checkGroupFinished || data.checkGroupLoadingMore) return;
        data.checkGroupLoadingMore = true;
      }
      try {
        const res = await GetCheckItemGroupList({
          company_id: props.company_id,
          page: data.checkGroupPage,
          pageSize: data.checkGroupPageSize,
        });
        if (res && res.code == 200) {
          const body = res.data && !Array.isArray(res.data) ? res.data : res;
          const rows = normalizeCheckGroups(res.rows || body.rows);
          const total = res.total ?? body.total ?? 0;
          data.checkGroupTotal = total;
          data.checkGroupOptions = reset
            ? rows
            : data.checkGroupOptions.concat(rows);
          // 返回不足一页 或 已取满 total => 没有更多
          if (
            rows.length < data.checkGroupPageSize ||
            (total && data.checkGroupOptions.length >= total)
          ) {
            data.checkGroupFinished = true;
          } else {
            data.checkGroupPage += 1;
          }
        } else {
          data.checkGroupError = true;
          if (res && res.msg) Toast(res.msg);
        }
      } catch (e) {
        data.checkGroupError = true;
        Toast("加载点检项目组失败");
      } finally {
        data.checkGroupLoading = false;
        data.checkGroupLoadingMore = false;
      }
    };

    // 触底加载下一页
    const loadMoreCheckGroup = () => {
      loadCheckGroups(false);
    };

    // 打开弹窗：每次重新拉取第一页（与 PC 端 destroy-on-close 行为一致），并回显已选
    const openCheckGroupDialog = async () => {
      data.tempCheckGroupIds = data.itemGroupDataList.map((g) => idOf(g.id));
      data.checkGroupDialog = true;
      await loadCheckGroups(true);
    };

    // 确定：回填已选（保留旧行的展开状态与明细缓存；已选但未加载到的项也不会丢）
    const confirmCheckGroup = () => {
      const prev = new Map(data.itemGroupDataList.map((g) => [idOf(g.id), g]));
      const optionMap = new Map(
        data.checkGroupOptions.map((g) => [idOf(g.id), g])
      );
      const picked = [];
      data.tempCheckGroupIds.forEach((id) => {
        const old = prev.get(id);
        if (old) {
          picked.push(old);
          return;
        }
        const opt = optionMap.get(id);
        if (opt) {
          // 弹窗里已展开加载过明细的直接带到已选列表，避免已选卡片再请求一次
          const loaded = opt._childLoaded && Array.isArray(opt._children);
          picked.push(
            Object.assign(opt, {
              _children: loaded ? opt._children : [],
              _childLoaded: !!loaded,
              _childLoading: false,
              _expanded: false,
              _open: false,
            })
          );
        }
      });
      data.itemGroupDataList = picked;
      data.checkGroupDialog = false;
      errors.check_item_list = "";
    };

    // 展开项目组：按 group_id 懒加载点检项
    const loadGroupItems = async (row) => {
      if (!row || row._childLoaded || row._childLoading) return;
      row._childLoading = true;
      try {
        const res = await GetCheckItemListByGroupId({ group_id: row.id });
        if (res && res.code == 200) {
          row._children = Array.isArray(res.data) ? [...res.data] : [];
        } else {
          row._children = [];
          if (res && res.msg) Toast(res.msg);
        }
      } catch (e) {
        row._children = [];
        Toast("加载点检项失败");
      } finally {
        row._childLoaded = true;
        row._childLoading = false;
      }
    };

    const toggleGroup = (row) => {
      row._expanded = !row._expanded;
      if (row._expanded) loadGroupItems(row);
    };

    // 弹窗内展开 / 收起项目组明细（明细不支持全量下发，展开时按需请求）
    const toggleGroupItems = (row) => {
      row._open = !row._open;
      if (row._open) loadGroupItems(row);
    };

    const removeGroup = (row) => {
      data.itemGroupDataList = data.itemGroupDataList.filter(
        (g) => idOf(g.id) !== idOf(row.id)
      );
      if (!data.itemGroupDataList.length) {
        errors.check_item_list = "请至少选择一项点检项目组";
      }
    };

    // ===== ③ 班组 =====
    // GetTeamEmp 返回「公司 → 班组 → 成员」三级树，这里拍平成班组列表
    // 兼容直接返回班组数组的情况
    // 员工节点映射（字段对齐 emergencyRepairWorkOrder 页对 GetTeamEmp 的解析）
    const mapEmp = (m) => ({
      emp_id: m.emp_id ?? m.team_emp_id ?? "",
      emp_code: m.emp_code ?? m.emp_no ?? "",
      emp_name: m.emp_name ?? m.user_name ?? "",
      is_improve: m.is_improve,
    });

    // GetTeamEmp 返回「公司 → 班组 → 员工」三级树。
    // 这里按节点特征识别层级、不写死层数：带 team_name/team_id 的是班组，
    // 带 emp_name/emp_code 的是员工，两者都不带的（公司节点）继续向下钻取。
    const normalizeTeams = (rows) => {
      const list = Array.isArray(rows) ? rows : [];
      const teams = [];

      const isEmpNode = (n) =>
        n.emp_name != null || n.emp_code != null || n.team_emp_id != null;
      const isTeamNode = (n) =>
        !isEmpNode(n) &&
        (n.team_name != null || n.team_code != null || n.team_id != null);

      const walk = (nodes, company_id) => {
        (nodes || []).forEach((n) => {
          if (!n) return;
          const cid = n.company_id ?? company_id ?? "";
          if (isTeamNode(n)) {
            const kids = Array.isArray(n.children) ? n.children : [];
            const members = (
              kids.length ? kids : n.emp_list || n.members || n.team_members || []
            ).map(mapEmp);
            teams.push({
              id: n.team_id ?? n.id ?? n.team_code ?? "",
              team_name: String(n.team_name ?? n.name ?? "").trim(),
              company_id: cid,
              members,
              _open: false, // 弹窗内是否展开成员
            });
          } else {
            walk(n.children, cid);
          }
        });
      };

      walk(list, "");
      return teams;
    };

    // 分页取数：reset=true 拉第一页，reset=false 触底加载下一页
    // 注：当前数据源（GetTeamEmp）是一次性返回全量树，所以首屏即全部数据；
    //     后续若换成 PC 端班组分页接口，只需把 finally 里的 teamFinished 改成按 page 判断
    const loadTeams = async (reset = false) => {
      if (reset) {
        data.teamPage = 1;
        data.teamOptions = [];
        data.teamFinished = false;
        data.teamError = false;
        data.teamLoading = true;
      } else {
        if (data.teamFinished || data.teamLoadingMore) return;
        data.teamLoadingMore = true;
      }
      try {
        // 与项目内既有用法一致（emergencyRepairWorkOrder 页传空对象），
        // 确保接口下发完整的「公司 → 班组 → 员工」树
        const res = await GetTeamEmp({});
        if (res && res.code == 200) {
          let rows = normalizeTeams(res.data);
          // 公司过滤放在客户端做；过滤结果为空时保留全量，
          // 避免公司字段类型不一致导致班组列表整个空白
          if (props.company_id) {
            const hit = rows.filter(
              (t) => String(t.company_id) === String(props.company_id)
            );
            if (hit.length) rows = hit;
          }
          data.teamOptions = reset ? rows : data.teamOptions.concat(rows);
        } else {
          if (reset) data.teamOptions = [];
          data.teamError = true;
          if (res && res.msg) Toast(res.msg);
        }
      } catch (e) {
        if (reset) data.teamOptions = [];
        data.teamError = true;
        Toast("加载班组失败");
      } finally {
        data.teamLoading = false;
        data.teamLoadingMore = false;
        // 全量数据源：一次即为末页
        data.teamFinished = true;
      }
    };

    // 触底加载下一页（当前数据源无更多数据，此处作为分页入口预留）
    const loadMoreTeam = () => {
      loadTeams(false);
    };

    const openTeamDialog = async () => {
      data.tempTeamIds = data.teamDataList.map((t) => idOf(t.id));
      data.teamDialog = true;
      await loadTeams(true);
    };

    const confirmTeam = () => {
      const prev = new Map(data.teamDataList.map((t) => [idOf(t.id), t]));
      const optionMap = new Map(data.teamOptions.map((t) => [idOf(t.id), t]));
      const picked = [];
      data.tempTeamIds.forEach((id) => {
        const old = prev.get(id);
        if (old) {
          picked.push(old);
          return;
        }
        const opt = optionMap.get(id);
        if (opt) {
          // 成员随班组列表一起返回，无需二次请求
          picked.push({
            id: opt.id,
            team_name: opt.team_name,
            _children: opt.members || [],
            _childLoaded: true,
            _childLoading: false,
            _expanded: false,
          });
        }
      });
      data.teamDataList = picked;
      data.teamDialog = false;
      errors.team_id = "";
    };

    const toggleTeam = (row) => {
      row._expanded = !row._expanded;
    };

    // 弹窗内展开 / 收起班组成员
    const toggleTeamMembers = (row) => {
      row._open = !row._open;
    };

    const removeTeam = (row) => {
      data.teamDataList = data.teamDataList.filter(
        (t) => idOf(t.id) !== idOf(row.id)
      );
      if (!data.teamDataList.length) {
        errors.team_id = "请至少选择一项班组";
      }
    };

    // ===== 展示辅助 =====
    const checkTypeText = (type) => {
      const hit = CHECK_TYPE_LIST.find((i) => i.value == type);
      return hit ? hit.label : "";
    };

    // 类型参考值
    const getCheckTypeInfo = (row) => {
      if (!row) return "";
      if (row.check_type == 0) return row.expected_bool ? "√" : "×";
      if (row.check_type == 1) return "[" + row.min_value + "," + row.max_value + "]";
      if (row.check_type == 2) {
        return (COMPARE_OPERATOR[row.compare_operator] || "") + row.compare_value;
      }
      if (row.check_type == 3) return row.expected_text;
      return "";
    };

    const memberText = (m) =>
      (m.emp_code ? m.emp_code + "-" : "") + (m.emp_name || "-");

    const isImprove = (m) => Number(m && m.is_improve) === 1;

    // ===== 对外：校验 / 取数（与 PC 端 defineExpose 一致） =====
    const validate = () =>
      new Promise((resolve) => {
        errors.check_item_list = data.itemGroupDataList.length
          ? ""
          : "请至少选择一项点检项目组";
        errors.team_id = data.teamDataList.length ? "" : "请至少选择一项班组";
        if (errors.check_item_list || errors.team_id) {
          Toast(errors.check_item_list || errors.team_id);
          resolve(false);
          return;
        }
        resolve(true);
      });

    // 只回传需要校验的两项（点检项目组 / 班组），公司、设备等宿主页面本已有
    const getFormData = () => ({
      itemGroupDataList: data.itemGroupDataList.map((item) => ({
        id: item.id,
        group_name: item.group_name,
        children: item._children || [],
      })),
      teamDataList: data.teamDataList.map((item) => ({
        id: item.id,
        team_name: item.team_name,
        children: item._children || [],
      })),
    });

    onMounted(() => {
      getAllCompany();
      //getEqpInfoById(props.eqp_info_id);
    });

    expose({ validate, getFormData });

    return {
      data,
      errors,
      companyText,
      isPicked,
      toggleTempId,
      loadMoreCheckGroup,
      openCheckGroupDialog,
      confirmCheckGroup,
      toggleGroup,
      toggleGroupItems,
      removeGroup,
      loadMoreTeam,
      openTeamDialog,
      confirmTeam,
      toggleTeam,
      toggleTeamMembers,
      removeTeam,
      checkTypeText,
      getCheckTypeInfo,
      memberText,
      isImprove,
    };
  },
};
</script>

<style scoped lang="scss">
.ck-form {
  min-height: 100%;
  background: #f7f8fa;
  /* 底部间距由宿主页面控制（ems 布局另有 tabbar 的 50px 占位） */
  padding-bottom: 16px;
}

/* 分组标题 */
.section {
  padding: 0 12px;
  margin-top: 4px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 4px 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;

  .title-bar {
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background: #1989fa;
  }

  .req {
    color: #ee0a24;
    font-size: 13px;
    margin-left: 2px;
  }

  .title-action {
    margin-left: auto;
    padding: 3px 12px;
    font-size: 13px;
    font-weight: 500;
    color: #1989fa;
    border: 1px solid #1989fa;
    border-radius: 14px;

    &:active {
      background: #eaf3ff;
    }
  }
}

/* 基础信息卡片 */
.info-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;

  :deep(.ro-field) {
    padding: 12px 16px;

    .van-field__label {
      color: #4e5969;
      font-size: 14px;
    }

    .van-field__control {
      color: #1d2129;
      font-size: 14px;
    }
  }
}

/* 已选列表 */
.sel-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sel-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.sel-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;

  &:active {
    background: #f7f8fa;
  }

  .sel-name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sel-arrow {
    flex-shrink: 0;
    font-size: 13px;
    color: #c9cdd4;
  }

  .sel-del {
    flex-shrink: 0;
    padding: 2px;
    font-size: 15px;
    color: #c9cdd4;

    &:active {
      color: #ee0a24;
    }
  }
}

.sel-body {
  padding: 0 14px 10px;
  border-top: 1px solid #f2f3f5;
}

.sel-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
}

/* 点检项行：名称 + k-v 明细 */
.item-row {
  padding: 10px 0;
  border-bottom: 1px dashed #f2f3f5;

  &:last-child {
    border-bottom: none;
  }
}

.item-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.item-name {
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
}

/* k-v：左标签定宽，右值自适应（长参考值换行） */
.kv {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 3px;
  font-size: 12px;
  line-height: 18px;
}

.kv-k {
  flex: 0 0 66px;
  color: #86909c;
}

.kv-v {
  flex: 1;
  min-width: 0;
  color: #4e5969;
  word-break: break-all;

  &.is-photo {
    color: #ff8f1f;
  }
}

/* 成员行 */
.member-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 0;
  border-bottom: 1px dashed #f2f3f5;

  &:last-child {
    border-bottom: none;
  }

  .member-name {
    font-size: 13px;
    color: #1d2129;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .member-tag {
    flex-shrink: 0;
    padding: 1px 6px;
    border-radius: 4px;
    font-size: 11px;
    color: #86909c;
    background: #f2f3f5;

    &.is-improve {
      color: #1e8e3e;
      background: #e6f6eb;
    }
  }
}

.empty-tip {
  padding: 14px 0;
  text-align: center;
  font-size: 12px;
  color: #c9cdd4;
}

/* 空态：可点击的占位卡片 */
.empty-card {
  padding: 22px 0;
  text-align: center;
  font-size: 13px;
  color: #a8abb2;
  background: #fff;
  border: 1px dashed #dcdee2;
  border-radius: 10px;

  &:active {
    background: #f7f8fa;
  }
}

.err-tip {
  margin-top: 6px;
  padding-left: 4px;
  font-size: 12px;
  color: #ee0a24;
}

/* 选择弹窗 */
.dlg {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dlg-head {
  position: relative;
  flex-shrink: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border-bottom: 1px solid #ebedf0;

  .dlg-title {
    font-size: 15px;
    font-weight: 600;
    color: #1d2129;
  }

  .dlg-cancel,
  .dlg-confirm {
    position: absolute;
    top: 0;
    font-size: 14px;
  }

  .dlg-cancel {
    left: 16px;
    color: #969799;
  }

  .dlg-confirm {
    right: 16px;
    color: #1989fa;
    font-weight: 600;
  }
}

.dlg-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.opt-row {
  padding: 0 16px;
  border-bottom: 1px solid #f2f3f5;
}

.opt-main {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 13px 0;

  &:active {
    background: #f7f8fa;
  }

  .opt-name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #1d2129;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .opt-sub {
    flex-shrink: 0;
    font-size: 12px;
    color: #86909c;
  }

  .opt-arrow {
    flex-shrink: 0;
    padding: 2px;
    font-size: 13px;
    color: #c9cdd4;
  }

  .opt-check {
    flex-shrink: 0;
  }
}

/* 弹窗内班组展开的成员列表 */
.opt-members {
  padding: 2px 0 8px;
  border-top: 1px dashed #f2f3f5;
}
</style>
